import { RocheIcon } from './roche-icon';
import { RocheTextLink } from './roche-text-link';
import { RocheOverline } from './roche-overline';
import { RocheCookieBannerLink } from './roche-cookie-banner-link';
import { RocheHeadline } from './roche-headline';

// For now just including the components that are used in richtext but we should use all components here
// and refactor blokToComponent, as well as editor.tsx to not use the storyblok-react package
// anymore and instead use @storyblok/react.
export const componentMapping = {
  'roche-icon': RocheIcon,
  'roche-text-link': RocheTextLink,
  'roche-headline': RocheHeadline,
  'roche-overline': RocheOverline,
  'roche-cookie-banner-link': RocheCookieBannerLink,
};
